/**
 * One catch-all route serves both public page kinds, so the segment itself
 * carries the type: a literal `t:` prefix means share token, everything else
 * is a username. react-router params match whole segments, so this prefix
 * check is the mechanism — not a workaround.
 *
 * New usernames and editable share tokens use the backend's common handle
 * grammar. Public usernames keep accepting legacy one- and two-character
 * rows, while newly chosen share tokens are 3..32.
 */
export type Slug = { kind: "share"; token: string } | { kind: "profile"; username: string } | null;

const SHARE_PREFIX = "t:";
// Two token eras remain routable: legacy 32-character URL-safe Base64 may
// have punctuation at either edge; newly chosen addresses may not.
const LEGACY_TOKEN = /^[A-Za-z0-9_-]{32}$/;
const TOKEN = /^[A-Za-z0-9][A-Za-z0-9._-]{1,30}[A-Za-z0-9]$/;
// Case-blind, the way the server reads it: usernames are stored lowercase,
// and "/Roma" typed into a bar is roma's page — the route redirects to the
// address as stored (see public-slug.tsx), not a 404 for a capital.
const USERNAME = /^[a-z0-9](?:[a-z0-9._-]{0,30}[a-z0-9])?$/i;

export function resolveSlug(slug: string): Slug {
  if (slug.startsWith(SHARE_PREFIX)) {
    const token = slug.slice(SHARE_PREFIX.length);
    return LEGACY_TOKEN.test(token) || TOKEN.test(token) ? { kind: "share", token } : null;
  }
  return USERNAME.test(slug) ? { kind: "profile", username: slug.toLowerCase() } : null;
}
